/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddTrackingLineRequest
 */
export interface AddTrackingLineRequest {
    /**
     * 
     * @type {string}
     * @memberof AddTrackingLineRequest
     */
    shipmentId: string;
    /**
     * 
     * @type {string}
     * @memberof AddTrackingLineRequest
     */
    message: string;
}

/**
 * Check if a given object implements the AddTrackingLineRequest interface.
 */
export function instanceOfAddTrackingLineRequest(value: object): value is AddTrackingLineRequest {
    if (!('shipmentId' in value) || value['shipmentId'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function AddTrackingLineRequestFromJSON(json: any): AddTrackingLineRequest {
    return AddTrackingLineRequestFromJSONTyped(json, false);
}

export function AddTrackingLineRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddTrackingLineRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'shipmentId': json['shipmentId'],
        'message': json['message'],
    };
}

  export function AddTrackingLineRequestToJSON(json: any): AddTrackingLineRequest {
      return AddTrackingLineRequestToJSONTyped(json, false);
  }

  export function AddTrackingLineRequestToJSONTyped(value?: AddTrackingLineRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shipmentId': value['shipmentId'],
        'message': value['message'],
    };
}

